module.exports = __webpack_public_path__ + "img/6.95d108a3.jpg";